<template>
  <div>
    <Container class="md:m-0 mx-auto">
      <template #header>
        <!-- <div class="tabs"> -->
        <div
          class="tab"
          :class="{ tab_active: activeTab === 'transactions' }"
          @click="changeTab('transactions')"
        >
          {{ $t("Transactions") }}
        </div>
        <!-- </div> -->
      </template>
      <template #body>
        <template v-if="!loading">
          <div class="w-full">
            <transaction-card
              v-for="(transaction, index) in data"
              :key="index"
              :item="parseTransaction(transaction)"
              :is-tron-transfer="activeTab === 'transfers'"
              class="first:mt-4 mt-2"
            />
            <div v-if="isLoadingMore" class="flex flex-col gap-2 w-full">
              <base-skeleton
                v-for="skeleton in 3"
                :key="`loading-more-${skeleton}`"
                class="w-full h-[198px] mt-2 rounded-md"
              />
            </div>
            <div class="show-more-container">
              <BaseButton @click="onLoadMore" v-if="hasMore" type="shade">
                {{ $t("PaginationButton | ShowMore") }}
              </BaseButton>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col gap-2 w-full">
            <base-skeleton
              v-for="skeleton in 20"
              :key="skeleton"
              class="w-full h-[198px] first:mt-4 mt-2 rounded-md"
            />
          </div>
        </template>
      </template>
    </Container>
  </div>
</template>

<script setup>
import TransactionCard from "@/entities/transaction-card/ui/index.vue";
import { Container, BaseButton } from "@/shared/ui";
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";

import { formatDate } from "@/shared/utils/format";

defineProps({
  activeTab: {
    type: String,
    required: true,
  },
  data: {
    type: Array,
    required: true,
  },
  loading: {
    type: Boolean,
    default: true,
  },
  // Флаг, указывающий, есть ли еще данные для загрузки
  hasMore: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["load-more", "changeTypeOfData"]);

const onLoadMore = () => {
  emit("load-more");
};
const changeTab = (type) => {
  emit("changeTypeOfData", type);
};

function parseTransaction(transactionItem) {
  if (!transactionItem) throw new Error("Error parsing transaction data");

  const { block, status, direction, network, hash, details } = transactionItem;

  // Extract token information if available
  const tokenInfo = details?.token_info || {};

  // Get the amount details - use token_transfer for TRC10 tokens if value doesn't exist
  const amountDetails = details.value || details.token_transfer || {};

  // Pass the whole value object as amountDetails
  return {
    timestamp: formatDate(block?.timestamp),
    hash: hash,
    amountDetails: amountDetails, // Use the extracted amount details
    confirmationCount: status?.confirmations,
    confirmed: status?.confirmed,
    network,
    direction,
    // Tron-specific data
    tokenType: details?.tx_type || null,
    tokenInfo: tokenInfo,
    energyUsed: details?.energy_used || null,
    // Only show error if confirmations = 0 AND the transaction is confirmed
    error: status?.confirmations === 0 && status?.confirmed === true,
  };
}
</script>

<style scoped lang="scss">
:deep(.container) {
  gap: 0; // Сброс отступа для правильного отображения табов
}

.title {
  margin-bottom: 12px;
}

.tab {
  margin-bottom: 11px;
}

.tabs {
  display: flex;
  gap: 23px;

  .tab {
    cursor: pointer;
    margin-bottom: 32px;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    color: var(--light-950);
    transition: color 0.1s ease;

    &:hover {
      color: var(--light-600);
    }

    &_active {
      color: #ffffff;
    }
  }
}

.arrow {
  transition: transform 0.3s ease;
  transform: rotate(90deg);
  width: 16px;
  height: 16px;
}

.show-more-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 16px;
}
</style>
